import styled from 'styled-components'

export const LiveDataTabContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`

export const LiveDataTabStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding-left: 10px;
`

export const LiveDataTabStatusLabel = styled.div`
  font-size: 1rem;
  font-weight: 700;
`

export const LiveDataTabStatusContent = styled.div`
  font-size: 1rem;
  font-weight: 500;
`

export const ChartContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const MewsChartsContainer = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 33% 33% 33%;
  grid-template-rows: 48% 48%;
  height: 500px;
  row-gap: 4%;
  column-gap: 0.5%;
`

export const ChartTitle = styled.span`
  font-size: 1rem;
  font-weight: 500;
  padding-left: 20px;
  padding-bottom: 20px;
`

export const EcgChartsContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 0.375rem;
  padding: 1rem;
`

export const EcgChartWrapper = styled.div`
  height: 15rem;
`

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  align-items: center;
  flex-direction: column;
  gap: 6rem;
  padding: 6rem;
  flex: 1;
  min-height: 32rem;
  border-radius: 2px;
  border: 1px dashed #ccc;
`

export const LoadingContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  animation: pulse 2s infinite;

  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }
`

export const LoadingText = styled.p`
  font-size: 1.5rem;
  margin-bottom: 0px;
`

export const LoadingParagraph = styled.p`
  font-size: 1rem;
`
